import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Leasing } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, NO_ICON, SIZE_48 } from '@yme/atoms/button';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { SALES_FORCE_LEASING_ENDPOINT } from '@yme/common/endpoints';
import { getProfileMenuData } from '@yme/components/Header/ProfileMenu/redux/selectors';
import { useProfileMenu } from '@yme/components/Header/SignInMenuItem/useProfileMenu';
import { ProductBanner } from '@yme/molecules/product-banner';
import { getProductCardLabels } from '@yme/pdp-components/ProductCard';
import { getCurrentCountryRoot, getRTL } from '@yme/selectors/common';
import { LEASING_ENABLED_KEY } from '@yme/selectors/constants';
import { getAttribute } from '@yme/selectors/products';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const LeasingPayments = (props) => {
    const { isAuthorized, sku, separatorText } = props;
    const isRightToLeft = useSelector(getRTL);
    const productCardLabels = useSelector(getProductCardLabels);
    const currentCountry = useSelector(getCurrentCountryRoot);
    const isLeasingEnabled = useSelector(getAttribute(LEASING_ENABLED_KEY));
    const { productCard_leasingCard_description: leasingDescription, productCard_leasingCard_apply: leasingButtonApply, productCard_leasingCard_loginToApply: leasingButtonLoginToApply, productCard_leasingCard_title: leasingTitle, } = productCardLabels;
    const { myYamahaLink } = useSelector(getProfileMenuData);
    const { signInHandler } = useProfileMenu();
    const applyLeasingHandler = useCallback(() => {
        window.location.href = `${myYamahaLink}${SALES_FORCE_LEASING_ENDPOINT}?sku=${sku}&language=${currentCountry}`;
    }, [currentCountry, myYamahaLink, sku]);
    const onHandleClick = isAuthorized ? applyLeasingHandler : signInHandler;
    const label = isAuthorized ? leasingButtonApply : leasingButtonLoginToApply;
    return (React.createElement(React.Fragment, null, isLeasingEnabled && (React.createElement(ProductBanner, { headerTextNode: React.createElement(RegularTextLevel3, { color: colorCoreBlack900Base, weight: 500 }, leasingTitle), separatorText: separatorText, description: leasingDescription, icon: React.createElement(SVGIcon, { type: Leasing, size: ICON_SIZE.xs }) },
        React.createElement(Button, { buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON, size: SIZE_48, onClick: onHandleClick, label: label, isRightToLeft: isRightToLeft })))));
};
